module.exports = __webpack_public_path__ + "img/dot.47b36151.svg";